import {
  GMAIL_CONNECTION_STATUS_REQUEST,
  GMAIL_CONNECTION_STATUS_SUCCESS,
  GMAIL_CONNECTION_STATUS_FAIL,
  GMAIL_CONNECT_REQUEST,
  GMAIL_CONNECT_SUCCESS,
  GMAIL_CONNECT_FAIL,
  GMAIL_DISCONNECT_REQUEST,
  GMAIL_DISCONNECT_SUCCESS,
  GMAIL_DISCONNECT_FAIL,
  SCAN_GMAIL_INBOX_REQUEST,
  SCAN_GMAIL_INBOX_SUCCESS,
  SCAN_GMAIL_INBOX_FAIL,
  SCAN_GMAIL_INBOX_STATUS_UPDATE,
  LIST_STAGED_ITBS_REQUEST,
  LIST_STAGED_ITBS_SUCCESS,
  LIST_STAGED_ITBS_FAIL,
  IMPORT_ITBS_REQUEST,
  IMPORT_ITBS_SUCCESS,
  IMPORT_ITBS_FAIL,
  IMPORT_ITBS_STATUS_UPDATE,
  REJECT_ITB_REQUEST,
  REJECT_ITB_SUCCESS,
  REJECT_ITB_FAIL,
  ITB_SELECT,
  ITB_SELECT_ALL,
  ITB_DESELECT_ALL,
  ITB_CLEAR_SELECTION,
  ITB_SET_FILTER,
  ITB_SET_SUCCESS_MESSAGE,
  ITB_SET_ERROR_MESSAGE,
  ITB_CLEAR_MESSAGES,
} from "../../constants/itbConstants";

const initialState = {
  // Gmail Connection
  gmailStatus: {
    is_connected: false,
    connected_email: null,
    connected_at: null,
  },
  loadingStatus: false,
  connecting: false,
  disconnecting: false,
  scanning: false,
  scanStatus: null, // { status, message, progress, total, itbs_found }
  stagedITBs: [],
  loadingITBs: false,
  counts: { pending: 0, imported: 0, rejected: 0 },
  selectedITBs: [],
  importing: false,
  importStatus: null, // { status, message, progress, total, imported_count, errors }
  filter: "pending",
  successMessage: "",
  errorMessage: "",
};

export const itbReducer = (state = initialState, action) => {
  switch (action.type) {
    case GMAIL_CONNECTION_STATUS_REQUEST:
      return { ...state, loadingStatus: true };

    case GMAIL_CONNECTION_STATUS_SUCCESS:
      return {
        ...state,
        loadingStatus: false,
        gmailStatus: action.payload,
      };

    case GMAIL_CONNECTION_STATUS_FAIL:
      return {
        ...state,
        loadingStatus: false,
        gmailStatus: {
          is_connected: false,
          connected_email: null,
          connected_at: null,
        },
      };

    case GMAIL_CONNECT_REQUEST:
      return { ...state, connecting: true };

    case GMAIL_CONNECT_SUCCESS:
    case GMAIL_CONNECT_FAIL:
      return { ...state, connecting: false };

    case GMAIL_DISCONNECT_REQUEST:
      return { ...state, disconnecting: true };

    case GMAIL_DISCONNECT_SUCCESS:
      return {
        ...state,
        disconnecting: false,
        gmailStatus: action.payload,
        stagedITBs: [],
        counts: { pending: 0, imported: 0, rejected: 0 },
      };

    case GMAIL_DISCONNECT_FAIL:
      return { ...state, disconnecting: false };

    case SCAN_GMAIL_INBOX_REQUEST:
      return { ...state, scanning: true };

    case SCAN_GMAIL_INBOX_SUCCESS:
      return {
        ...state,
        scanning: false,
        stagedITBs: (() => {
          const existingIds = new Set(state.stagedITBs.map((itb) => itb.email_id));
          const newITBs = action.payload.staged_itbs || [];
          const uniqueNewITBs = newITBs.filter(
            (itb) => !existingIds.has(itb.email_id)
          );
          return [...state.stagedITBs, ...uniqueNewITBs];
        })(),
      };

    case SCAN_GMAIL_INBOX_FAIL:
      return { ...state, scanning: false, scanStatus: null };

    case SCAN_GMAIL_INBOX_STATUS_UPDATE:
      return {
        ...state,
        scanStatus: action.payload,
        scanning: action.payload?.status === 'processing' || action.payload?.status === 'queued',
      };

    case LIST_STAGED_ITBS_REQUEST:
      return { ...state, loadingITBs: true };

    case LIST_STAGED_ITBS_SUCCESS:
      return {
        ...state,
        loadingITBs: false,
        stagedITBs: action.payload.staged_itbs || [],
        counts: action.payload.counts || { pending: 0, imported: 0, rejected: 0 },
      };

    case LIST_STAGED_ITBS_FAIL:
      return {
        ...state,
        loadingITBs: false,
        stagedITBs: [],
        counts: { pending: 0, imported: 0, rejected: 0 },
      };

    case IMPORT_ITBS_REQUEST:
      return { ...state, importing: true };

    case IMPORT_ITBS_SUCCESS:
      return {
        ...state,
        importing: false,
        selectedITBs: [],
      };

    case IMPORT_ITBS_FAIL:
      return { ...state, importing: false, importStatus: null };

    case IMPORT_ITBS_STATUS_UPDATE:
      return {
        ...state,
        importStatus: action.payload,
        importing: action.payload?.status === 'processing' || action.payload?.status === 'queued',
      };

    case REJECT_ITB_REQUEST:
      return { ...state };

    case REJECT_ITB_SUCCESS:
      return {
        ...state,
        stagedITBs: state.stagedITBs.filter((itb) => itb.id !== action.payload),
      };

    case REJECT_ITB_FAIL:
      return { ...state };

    case ITB_SELECT:
      return {
        ...state,
        selectedITBs: state.selectedITBs.includes(action.payload)
          ? state.selectedITBs.filter((id) => id !== action.payload)
          : [...state.selectedITBs, action.payload],
      };

    case ITB_SELECT_ALL:
      const pendingITBs = state.stagedITBs.filter(
        (itb) => itb.status === "pending"
      );
      return {
        ...state,
        selectedITBs: pendingITBs.map((itb) => itb.id),
      };

    case ITB_DESELECT_ALL:
      return {
        ...state,
        selectedITBs: [],
      };

    case ITB_CLEAR_SELECTION:
      return {
        ...state,
        selectedITBs: [],
      };

    case ITB_SET_FILTER:
      return {
        ...state,
        filter: action.payload,
        selectedITBs: [],
      };

    case ITB_SET_SUCCESS_MESSAGE:
      return {
        ...state,
        successMessage: action.payload,
        errorMessage: "",
      };

    case ITB_SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload,
        successMessage: "",
      };

    case ITB_CLEAR_MESSAGES:
      return {
        ...state,
        successMessage: "",
        errorMessage: "",
      };

    default:
      return state;
  }
};

